/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {mediaQuery, pxToEm} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : SIGN IN : STYLES --------------- ++++++++++ */
export default theme => ({
   propertycard: {
        position: 'relative',
        textAlign: 'left',
        '& .picker': {
            position: 'absolute',
            top: 0,
            '& .sketch-picker': {
                width: `${pxToEm(180)} !important`,
                borderRadius: '0 !important'
            }
        },
        '& .textfield':{
            fontFamily: `${theme.typography.font} !important`,
        },
        '& .controllercontainer':{
            '& .name-cardtitle': {
                '& h4':{
                    fontSize: pxToEm(14),
                    fontWeight: 'bold'
                }
            },
            '& .name-propertiestitle':{
                marginBottom: pxToEm(4)
            }
        },
        '& .controllercontainer > *':{
            marginBottom: pxToEm(24),
            '&:last-child': {
                marginBottom: pxToEm(0)
            }
        },
    }
});
